import React from 'react';
import { StyledAvatar as Avatar } from './Avatar.Styles';

export default Avatar;
